(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices/player-exclusions/assets/javascripts/data/active-exclusions.js') >= 0) return;  svs.modules.push('/components/accountservices/player-exclusions/assets/javascripts/data/active-exclusions.js'); 'use strict';

var logger = svs.core.log.getLogger('accountservices: player-exclusions');
var activeExclusionsCache;

var fetchAndCache = function fetchAndCache() {
  var cb = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};
  svs.core.jupiter.call({
    method: 'GET',
    path: '/player/1/customizedsettings'
  }, function (data) {
    var activeExclusions = svs.accountservices.player_exclusions.utils.processAPIData(data.customizedSettings.properties);
    activeExclusions = svs.accountservices.player_exclusions.utils.processAPIData(svs.core.userSession, activeExclusions);
    activeExclusionsCache = activeExclusions;
    svs.core.userSession.set('activeExclusions', svs.accountservices.player_exclusions.compressor.deflate(activeExclusions));
    cb(activeExclusions);
  }, function (err) {
    logger.error('Unable to get users self exclusions, returning no active pause', err);
    cb({
      hasPause: false
    });
  });
};


var get = function get() {
  var cb = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};

  if (activeExclusionsCache) {
    if (svs.accountservices.player_exclusions.utils.validateActiveExclusionsCache(activeExclusionsCache)) {
      cb(activeExclusionsCache);
    } else {
      fetchAndCache(cb);
    }
  } else {
    svs.core.userSession.get('activeExclusions', function (err, data) {
      if (err) {
        logger.error('Could not retrieve activeExlucions from userSession storage, getting from api instead', err);
        fetchAndCache(cb);
      } else if (data) {
        activeExclusionsCache = svs.accountservices.player_exclusions.compressor.inflate(data);

        if (activeExclusionsCache && svs.accountservices.player_exclusions.utils.validateActiveExclusionsCache(activeExclusionsCache)) {
          cb(activeExclusionsCache);
        } else {
          fetchAndCache(cb);
        }
      } else {
        fetchAndCache(cb);
      }
    });
  }
};

var reset = function reset(partial) {
  activeExclusionsCache = undefined;

  if (!partial && svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER)) {
    svs.core.userSession.remove('activeExclusions');
  }
};


var set = function set(exclusions, successFn) {
  var saveToSessionStorage = function saveToSessionStorage() {
    return svs.core.userSession.set('activeExclusions', svs.accountservices.player_exclusions.compressor.deflate(activeExclusionsCache), successFn);
  };

  activeExclusionsCache = exclusions;
  svs.core.jupiter.call({
    method: 'DELETE',
    path: '/player/1/onlineflag/lcHideVertical'
  }, saveToSessionStorage, function (err) {
    logger.warn('Unable to unset lcHideVertical flag at /player/1/onlineflag/lcHideVertical', err);
    saveToSessionStorage();
  });
};

svs.accountservices.player_exclusions.activeExlucions = {
  get: get,
  reset: reset,
  set: set
};
 })(window);